// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-module--logo--1Nn6w","barmer":"logo-module--barmer--2O4EK"};